import { render, staticRenderFns } from "./PhoneDialog.vue?vue&type=template&id=566c8e9b&scoped=true&"
import script from "./PhoneDialog.vue?vue&type=script&lang=js&"
export * from "./PhoneDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566c8e9b",
  null
  
)

export default component.exports